<!-- Site Switcher button on Toolbar -->
@if(isUnEnabledForCurrentApp()) {
  @if (isShowingSiteSwitcher() && enrolledSites$ | async) {
    @if (siteSwitcherOptionCount > 0 && !isGuest) {
      <button
        #siteSwitchTrigger="matMenuTrigger"
        id="site-switcher-toolbar-button"
        class="toolbar-site-switch-container"
        [class.btn-hover]="!isDDorCollections()"
        [matMenuTriggerFor]="isMobile ? null : siteSwitch"
        aria-label="Switch school"
        type="button"
        (click)="isMobile ? showInSidenav() : null"
        (menuOpened)="onSiteSwitcherOpen()"
        >
        @if (isMobile) {
          <fa-icon class="school-icon" [icon]="['far', 'school']"></fa-icon>
        }
        @if (!isMobile) {
          <span id="current-site-name" class="button-text">{{getButtonText()}}</span>
        }
        <fa-icon [icon]="['fas', 'chevron-down']"></fa-icon>
      </button>
    }
    @if (siteSwitcherOptionCount === 0 || isGuest || isShared) {
      <div class="toolbar-site-switch-container">
        @if (isMobile) {
          <fa-icon class="school-icon" [icon]="['far', 'school']"></fa-icon>
        }
        @if (!isMobile) {
          <span id="current-site-name" class="button-text">{{getButtonText()}}</span>
        }
      </div>
    }
  }
} @else {
  @if (enrolledSites$ | async) {
    <button
      #siteSwitchTrigger="matMenuTrigger"
      id="site-switcher-toolbar-button"
      [matMenuTriggerFor]="siteSwitch"
      mat-icon-button
      aria-label="Switch school"
      type="button"
      (click)="closeOldMobileSidenav()"
      (menuOpened)="onSiteSwitcherOpen()"
      >
      <mat-icon [svgIcon]="icons.SCHOOL" title="Switch school"></mat-icon>
    </button>
  }
}

<mat-menu #siteSwitch="matMenu" class="fss-user-profile-menu">
  <div cdkTrapFocus>
    <ng-template #siteSwitcherTemplate>
      <div
        (click)="$event.stopPropagation()"
        (keydown.tab)="$event.stopPropagation()"
        (keydown.shift.tab)="$event.stopPropagation()"
        class="site-switch-menu-container"
        [class.un]="isUnEnabledForCurrentApp()"
        >
        <div id="site-switch-header" class="site-switch-header">
          @if (!isUnEnabledForCurrentApp()) {
            <p class="site-switch-title">My schools ({{ enrolledSiteCount }})</p>
          }

          @if (enrolledSiteCount > 10) {
            <div id="search-area" class="search-area">
              <input
                #schoolFilterInput
                matInput
                id="school-filter-input"
                class="searchbox"
                type="text"
                placeholder="Search Sites"
                [(ngModel)]="searchText"
                (input)="filterSearchText()"
                (change)="filterSearchText()"
                (blur)="hackToHandleSearchFocus($event)"
                />
                @if (!searchText || searchText.length === 0) {
                  <span id="search-icon" class="simple-search__icon">
                    @if (!isUnEnabledForCurrentApp()) {
                      <mat-icon class="search-icons" [svgIcon]="icons.SEARCH"></mat-icon>
                    }
                    @if (isUnEnabledForCurrentApp()) {
                      <fa-icon class="search-icons" [icon]="['far', 'magnifying-glass']"></fa-icon>
                    }
                  </span>
                }
                @if (searchText?.length > 0) {
                  <button title="Clear search term" id="clear-search-icon-btn"
                    class="simple-search__cancel" (click)="clearSearchText(); focus();" type="button">
                    @if (!isUnEnabledForCurrentApp()) {
                      <mat-icon class="search-icons" [svgIcon]="icons.CLEAR"></mat-icon>
                    }
                    @if (isUnEnabledForCurrentApp()) {
                      <fa-icon class="search-icons" [icon]="['far', 'circle-x']"></fa-icon>
                    }
                  </button>
                }
              </div>
            }
          </div>
          @if (currentSite && !isUnEnabledForCurrentApp()) {
            <div
              (click)="$event.stopPropagation()"
              id="selected-site"
              class="selected-site">
              {{ currentSite.siteName }} (current)
            </div>
          }
          @if (enrolledSiteCount > 0) {
            <mat-selection-list id="enrolled-scroll-area" class="enrolled-scroll-area __scroll">
              @for (option of filteredSites; track option.guid; let i = $index) {
                <mat-list-option
                  id="enrolled-school-{{ i }}"
                  [value]="option"
                  (click)="switchSiteTo(option)"
                  (keydown.enter)="switchSiteTo(option)"
                  type="button"
                  class="site-option"
                  >
                  <span id="enrolled-school-{{i}}-name" class="site-text">
                    {{ option.siteName }}
                  </span>
                </mat-list-option>
              }
            </mat-selection-list>
          }
          @if (filteredSites.length === 0 && enrolledSiteCount > 1 && isUnEnabledForCurrentApp()) {
            <div
              class="no-results-found"
              >
              <fa-icon [icon]="['far', 'magnifying-glass-minus']"></fa-icon>
              No results found
            </div>
          }
          @if (showSelectAll()) {
            <div class="view-all-section">
              @if (!isUnEnabledForCurrentApp() || (isUnEnabledForCurrentApp() && enrolledSiteCount > 1)) {
                <mat-divider></mat-divider>
              }
              <button (click)="viewAllSites()" id="select-all-sites" class="view-all-site-option" type="button">
                <span class="site-text">
                  {{isUnEnabledForCurrentApp() ? 'Go to District View' : 'View All Sites'}}
                </span>
              </button>
            </div>
          }
        </div>
      </ng-template>
      <ng-container *ngTemplateOutlet="siteSwitcherTemplate"></ng-container>
    </div>
  </mat-menu>
